import getProp from '@f/get-prop'

export function isShowingChangePlanConfirm (state) {
  const showing = getProp('application.workspaceSettings.isShowingChangePlanConfirm', state)
  return showing === true
}



// WEBPACK FOOTER //
// ./selectors/plan-migration.js